import React, { useState } from 'react'
import { INSTALL_STATUS, UNINSTALL } from '@/constants/util'
import { Table, Divider, Popconfirm } from 'antd'
import { deleteTry } from '@/api/equipment'
import {
  notInstallAndNotBind,
  notInstallAndBind,
  installAndBind,
  install,
} from './util'
import { message } from 'antd'

const Content = (props) => {
  const {
    dataSource,
    page,
    onTableChange = () => {},
    onShowSizeChange = () => {},
    onEdit = () => {},
    onRefresh = () => {},
    onUpdate = () => {},
    selectedRowKeys,
    onChangeSelectedRowKeys = () => {},
  } = props

  const confirmDelete = (current) => () => {
    deleteTry({ id: current.capsuleId }).then((res) => {
      if (res.success) {
        message.success('删除设备成功')
        onRefresh()
      }
    })
  }

  const renderAction = (record) => {
    let arr = []
    if (installAndBind(record)) {
      arr.push(<a onClick={() => onUpdate(record)}>更新</a>)
    }
    if (!installAndBind(record)) {
      arr.push(<a onClick={() => onEdit(record)}>编辑</a>)
    }
    if (notInstallAndNotBind(record)) {
      arr.push(
        <Popconfirm
          title='确定删除此设备吗，删除将无法恢复?'
          onConfirm={confirmDelete(record)}
          okText='确定'
          cancelText='取消'>
          <a href='#' style={{ margin: '0 10px' }}>
            删除
          </a>
        </Popconfirm>
      )
    }
    let arrLen = arr.length
    arr.forEach((item, index) => {
      if (arrLen - 1 > index) {
        // arr.splice(index + 1, 0, <Divider type="vertical" />);
      }
    })
    return arr
  }

  const columns = [
    {
      title: '设备编号',
      dataIndex: 'capsuleNo',
      key: 'capsuleNo',
    },
    {
      title: '控制板编号',
      dataIndex: 'roboId',
      key: 'roboId',
    },
    {
      title: '绑定状态',
      dataIndex: 'bindState',
      key: 'bindState',
      render: (text) => {
        return (
          <div className={text ? '' : 'disabled-text'}>
            {text ? '已绑定' : '未绑定'}
          </div>
        )
      },
    },
    {
      title: '运营商',
      dataIndex: 'companyName',
      key: 'companyName',
    },
    {
      title: '安装状态',
      dataIndex: 'status',
      key: 'status',
      render: (text) => {
        return (
          <div className={text === UNINSTALL ? 'disabled-text' : ''}>
            {INSTALL_STATUS[text]}
          </div>
        )
      },
    },
    {
      title: '当前软件版本',
      dataIndex: 'versionName',
      key: 'versionName',
    },
    {
      title: '当前硬件版本',
      dataIndex: 'hardwareVersion',
      key: 'hardwareVersion',
    },
    {
      title: '操作',
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => {
        return renderAction(record)
      },
    },
  ]

  const handleChangeCheck = (selectedRowKeys, selectedRows) => {
    const rightSelectedRows = selectedRows.filter((selected) =>
      install(selected)
    )
    if (rightSelectedRows.length !== selectedRows.length) {
      message.warning('您的勾选项存在无法更新的情况!')
    }
    onChangeSelectedRowKeys(rightSelectedRows.map((item) => item.capsuleId))
  }

  return (
    <div className='content'>
      <Table
        rowSelection={{
          selectedRowKeys,
          onChange: handleChangeCheck,
          getCheckboxProps: (current) => {
            return {
              disabled: !install(current),
            }
          },
        }}
        dataSource={dataSource}
        rowKey='capsuleId'
        columns={columns}
        pagination={{
          showTotal: () => `共${page.total}条`,
          total: page.total,
          current: page.pageNum,
          pageSize: page.pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ['10', '20', '30', '40'],
          onChange: onTableChange,
          onShowSizeChange: onShowSizeChange,
        }}
      />
    </div>
  )
}

export default Content
